import { Link } from "react-router-dom";

export function PrivacyNote({ dark = false }) {
  return (
    <p data-testid="privacy-note" style={{ color: dark ? 'rgba(255,255,255,0.55)' : '#777', fontSize: '12px', textAlign: 'center', margin: '4px 0 0', lineHeight: 1.5 }}>
      Vos coordonnées servent uniquement à traiter votre demande (
      <Link to="/mentions-legales" style={{ color: dark ? '#fff' : '#8B0000', textDecoration: 'underline' }}>politique de confidentialité</Link>).
    </p>
  );
}

export function Honeypot({ value, onChange }) {
  return (
    <div aria-hidden="true" style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', overflow: 'hidden' }}>
      <label>Site web<input type="text" name="website" tabIndex={-1} autoComplete="off" value={value} onChange={onChange} data-testid="honeypot-field" /></label>
    </div>
  );
}
